var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONContact extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.AG_departments = [];
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
    }
}
__decorate([
    array_property(Number),
    __metadata("design:type", Array)
], ewJSONContact.prototype, "AG_departments", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContact.prototype, "eier", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContact.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContact.prototype, "kundenr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContact.prototype, "navn", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContact.prototype, "orgnr", void 0);
